import { Table as ATable } from 'antd';
import SVGIcon from '../SVGIcon/SVGIcon';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Table = styled(ATable)<any>`
  @media screen and (max-width: 500px) {
    .ant-table-thead > tr {
      display: flex;
      justify-content: space-between;
      th:first-child {
        flex: 1;
      }
    }
    .ant-table-row td:not(:last-child) {
      border-bottom: none;
    }
    .ant-table-tbody > tr:hover,
    .ant-table-tbody > tr > td:hover {
      background-color: white !important;
    }
  }
  .ant-table-thead > tr > th {
    background: white;
    color: rgba(0, 0, 0, 0.54);
  }
  p {
    display: flex;
  }
  .label {
    color: rgba(0, 0, 0, 0.54);
    flex: 1;
  }
`;

export const NoteIcon = styled(SVGIcon)<any>`
  ${({ note }) =>
    note === 'true'
      ? `
    path {
      fill: #2e904e;
    }
  `
      : ``};
`;

export const Label = styled.span`
  color: rgba(0, 0, 0, 0.54);
  min-width: 80pt;
  margin-right: 10pt;
`;

export const ExpandIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 8px;
`;

export const OrderContainer = styled.div`
  border-radius: 8px;
  overflow-x: auto;
  width: 100%;
`;

export const ItemCell = styled.div<any>`
  padding: 8px 12px;
  background: white;
  height: 60px;
  flex: ${({ flex }) => flex || '1 0 0'};
  flex-basis: ${({ fbasis }) => fbasis};
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
`;

export const OrderItemCell = styled.div<{ flexDirection?: 'row' | 'column' }>`
  padding: 12px;
  background: white;
  flex: ${({ flex }) => flex || '1 0 0'};
  flex-basis: ${({ fbasis }) => fbasis};
  text-align: ${({ textAlign }) => textAlign || 'left'};
  border-top: 1px solid #eaeaeb;
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ flexDirection }) => (flexDirection === 'column' ? 'flex-start' : 'center')};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
`;

export const OrderItem = styled.div<any>`
  display: flex;
  min-width: 100%;
  width: fit-content;
  justify-content: ${({ justify }) => (justify ? justify : 'flex-start')};
  align-items: stretch;
  box-sizing: border-box;
  transition: all 0.3s ease;
  background-color: white;
  &.header ${OrderItemCell} {
    border: none;
    color: rgba(0, 0, 0, 0.54);
    text-transform: capitalize;
  }
  &:hover:not(.header) ${ItemCell} {
    background-color: #f0f8fb;
  }
  &:hover:not(.header) ${OrderItemCell} {
    background-color: #fff;
  }
  &.header:hover {
    box-shadow: none;
  }
`;

export const StyledLink = styled(Link)`
  color: rgba(0, 0, 0, 0.87);
  &:hover {
    color: #40a9ff;
  }
  display: -webkit-inline-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
`;

export const OrderContainerMobile = styled.div``;

export const OrderItemMobile = styled.div`
  padding: 24px;
  border-bottom: 1px solid #e8e8e8;
`;

export const OrderContainerDesktop = styled.div`
  border: 1px solid #e8e8e8;
  margin: 24px;
`;
export const MoneyRow = styled.div<{ showInfoTooltip: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: ${({ showInfoTooltip }) => (showInfoTooltip ? '0' : '12px')};

    @media (max-width: 767px) {
      margin-bottom: 0;
    }
  }
`;
export const MoneyValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #343538;
`;

export const MoneyDiscountValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #43a047;
`;

export const MoneyLabel = styled.span`
  color: rgba(0, 0, 0, 0.54);
`;
